import React, { Component } from 'react'
import { Routes, Route } from 'react-router-dom'

import endPoints from '../../components/Consts/endPoints.json'

import { Workout, WorkoutForm } from '../../views/Workout'

export default class WorkoutRoute extends Component {
  render () {
    var releatedRoutes = endPoints.find(aa => aa.name == 'Workout')?.routes
    return (
      <Routes>
        <Route path={releatedRoutes?.get} exact element={<Workout />} />
        <Route path={releatedRoutes?.create} exact element={<WorkoutForm />} />
        <Route path={releatedRoutes?.update} exact element={<WorkoutForm />} />
        <Route path={releatedRoutes?.delete} exact element={<WorkoutForm />} />
      </Routes>
    )
  }
}
